// 流程管理
import { Form } from 'antd';
import TabDetail from './PageMine';
import PageWatch from './PageWatch';
import PageAdd from './PageAdd';

const router = {
  path: 'flow',
  breadcrumbName: '财务',
  childRoutes: [
    {
      path: 'add',
      breadcrumbName: '新建流程',
      component: PageAdd,
    },
    {
      path: 'mine',
      breadcrumbName: '我的流程',
      component: Form.create({ wrappedComponentRef: true })(TabDetail),
    },
    {
      path: 'watch',
      breadcrumbName: '流程监控',
      component: PageWatch,
    },
  ],
};

export default router;



// WEBPACK FOOTER //
// ./src/components/flow/router.js